jQuery(document).ready(function ($) {
  //fixed header
  $(window).on("scroll", () => {
    if (window.innerWidth >= 1280) {
      if ($(this).scrollTop() >= 200 && !$(".header1").hasClass("fixed")) {
        $("header").removeClass("md:container");
        $(".header1")
          .removeClass("absolute")
          .addClass("fixed")
          .css({ top: "-150px" })
          .animate({ top: "0px" }, 250);
      } else if (
        $(this).scrollTop() < 200 &&
        !$(".header1").hasClass("absolute")
      ) {
        $("header").addClass("md:container");
        $(".header1").removeClass("fixed");
        $(".header1").addClass("absolute");
      }
    } else {
      var footerRegister = document.getElementsByClassName("fixedMobile");
      if (footerRegister.length > 0) {
        if (
          $(window).scrollTop() >= window.innerHeight / 2 &&
          !$(".fixedMobile").hasClass("active") &&
          $(document).height() - 100 >=
            $(window).scrollTop() + window.innerHeight
        ) {
          $(".fixedMobile")
            .addClass("active")
            .css({ bottom: "-160px" })
            .animate({ bottom: "-10px" }, 250);
        } else if (
          ($(window).scrollTop() < window.innerHeight / 2 &&
            $(".fixedMobile").hasClass("active")) ||
          ($(document).height() - 100 <=
            $(window).scrollTop() + window.innerHeight &&
            $(".fixedMobile").hasClass("active"))
        ) {
          $(".fixedMobile").animate({ bottom: "-160px" }, 250);
          $(".fixedMobile").removeClass("active");
        }
      }
    }
  });

  //select language
  $(".btn-select").click(function () {
    $(".dropBox").toggle();
  });
  // Close dropdown when clicking anywhere else on the site
  $(document).click(function (event) {
    if (!$(event.target).closest(".relative").length) {
      $(".dropBox").hide();
    }
    if (!$(event.target).closest("#mobile-menu-opener").length) {
      var x = document.getElementById("menuList");
      x.classList.add("hidden");
    }
  });

  class Modal {
    constructor(modalSelector, buttonSelector) {
      this.maskModal = $(modalSelector);
      this.modal = this.maskModal.find(".mrm-modal");
      this.showBtn = $(buttonSelector);
      this.BG = document.querySelector("html");
      this.showBtn.on("click", this.openModal.bind(this));
      this.closeBtn = this.maskModal.find(".mrm-close-modal");
      this.closeBtn.on("click", this.closeModal.bind(this));
    }

    openModal() {
      $("html").css({ overflow: "hidden" });
      this.maskModal.addClass("active");
      this.modal.addClass("modal-active");
    }

    closeModal() {
      $("html").css({ overflow: "auto" });
      this.maskModal.removeClass("active");
      this.modal.removeClass("modal-active");
    }
  }

  // initialize the all modals
  const allModals = $(".mrm-mask-modal");
  const setupModals = allModals.map(function () {
    const triggers = $(this).data("triggers");
    const elementId = $(this).attr("id");
    return new Modal(`#${elementId}`, triggers);
  });

  var path = window.location.pathname;
  var params = window.location.search;
  if (path + params === "/?redirect=plan-registration") {
    setupModals[0].openModal();
  }

  if (path !== "/plan-register/") {
    localStorage.removeItem(`me_personalData`);
    localStorage.removeItem(`me_goldenPlansData`);
    localStorage.removeItem(`another_personalData`);
    localStorage.removeItem(`anothe_goldenPlansData`);
    localStorage.removeItem(`dead_personalData`);
  }
});

// hambrger menu
const openMobileMenu = document.querySelector("#mobile-menu-opener");
openMobileMenu.addEventListener("click", () => {
  var x = document.getElementById("menuList");
  if (x.classList.contains("hidden")) {
    x.classList.remove("hidden");
  } else {
    x.classList.add("hidden");
  }
});

jQuery(document).ready(function ($) {
  const moreCommentButton = document.querySelectorAll(".comment-more-button");
  if (moreCommentButton) {
    // Loop through each button
    moreCommentButton.forEach((button) => {
      // Add an event listener to the button to toggle the visibility of the next sibling
      button.addEventListener("click", function () {
        const hiddenContent = $(this).parent().next().html();
        // console.log(hiddenContent.html())
        let userCommentContainer = document.getElementById(
          "user-comment-container"
        );
        userCommentContainer.innerText = hiddenContent;
      });
    });
  }
});

document
  .getElementById("toggleButtonHeroSection")
  .addEventListener("click", () => {
    let truncatedContent = document.getElementById("heroTruncatedContent");
    let toggleButton = document.getElementById("toggleButtonHeroSection");
    let fullContent = document.getElementById("heroFullContent");

    if (fullContent.style.display === "none") {
      truncatedContent.style.display = "none";
      fullContent.style.display = "inline";
      toggleButton.innerText = "کمتر";
    } else {
      truncatedContent.style.display = "inline";
      fullContent.style.display = "none";
      toggleButton.innerText = "بیشتر";
    }
  });
